// Trafford Hero: auto-rotating crossfade carousel.
// Rotates .trafford-hero__slide elements by toggling .is-active (CSS handles the
// opacity crossfade). Starts only when in view, pauses when the tab is hidden,
// and does not auto-rotate under prefers-reduced-motion.
class TraffordHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.trafford-hero__slide'));
    this.intervalMs = parseInt(this.getAttribute('interval'), 10) || 5000;
    this.index = 0;
    this.timer = null;

    if (this.slides.length <= 1) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.start();
          } else {
            this.stop();
          }
        });
      },
      { threshold: 0.2 }
    );
    this.observer.observe(this);

    this.onVisibility = () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    };
    document.addEventListener('visibilitychange', this.onVisibility);
  }

  disconnectedCallback() {
    this.stop();
    if (this.observer) this.observer.disconnect();
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  start() {
    if (this.timer) return;
    this.timer = setInterval(() => this.next(), this.intervalMs);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  next() {
    this.slides[this.index].classList.remove('is-active');
    this.index = (this.index + 1) % this.slides.length;
    this.slides[this.index].classList.add('is-active');
  }
}

if (!customElements.get('trafford-hero')) {
  customElements.define('trafford-hero', TraffordHero);
}
